// extracted by mini-css-extract-plugin
module.exports = {"container":"Home_container__27ne1"};